import { render, staticRenderFns } from "./FontAwesomePickerModal.vue?vue&type=template&id=dc8371ca"
import script from "./FontAwesomePickerModal.vue?vue&type=script&lang=js"
export * from "./FontAwesomePickerModal.vue?vue&type=script&lang=js"
import style0 from "./FontAwesomePickerModal.vue?vue&type=style&index=0&id=dc8371ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports